export const state = {
  invoices: [],
  currentInvoice: null,

  ordersResponse: null,
}
